import { useState, useEffect } from 'react';
import React from 'react';
import axios from 'axios';
import { Container, Table, Button } from 'react-bootstrap';

const API_PORT = ':3033';
const URL_LOCALHOST = 'http://localhost' + API_PORT;
const URL_EXTERNAL_IP = 'http://192.168.66.142' + API_PORT;
axios.defaults.baseURL = URL_LOCALHOST;

const UserList = () => {
	const [users, setUser] = useState([]);

	useEffect(() => {
		getUsers();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const getUsers = async () => {
		try {
			const response = await axios.get('/api/get');
			setUser(response.data);
			console.log(users);
		} catch (err) {
			console.log('Error connecting to API');
		}
	}

	return (
		<Container className='border border-secondary'>

			{users.length === 0 ?
				<div>
					<p>No Data</p>
				</div>
				:
				<Table className="table table-hover">
					<thead>
						<tr>
							<th>#</th>
							<th>User</th>
							<th>Name</th>
							<th>Status</th>
							<th>Date</th>
						</tr>
					</thead>

					<tbody>
						{users.map((user, index) => (
							<tr key={user.id}>
								<td>{index + 1}</td>
								<td>{user.name}</td>
								<td>{user.full_name}</td>
								<td>{user.status_id}</td>
								<td>{new Date(user.createdOn).toISOString().split('T')[0]}</td>
							</tr>
						))}
					</tbody>

				</Table>}

			<div className='d-flex justify-content-start'>
				<Button variant='primary' size='sm'>Add User</Button>
			</div>
		</Container >
	)
}

export default UserList